import React, { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { RecordedSave } from "@/admin/Recorded";
import { Field, inputCls } from "@/components/common";

const NUM: [string, string][] = [["spend_per", "Spend (A$) to earn…"], ["earn_per", "…this much in rewards (A$)"], ["review", "Review reward (A$)"], ["review_photo", "Review with photo (A$)"],
  ["review_video", "Review with video (A$)"], ["facebook", "Facebook follow (A$)"], ["instagram", "Instagram follow (A$)"], ["pending_days", "Days before purchase rewards unlock"]];

export function RewardsSettings({ cfg, onSaved }: { cfg: any; onSaved: () => void }) {
  const [f, setF] = useState<any>(cfg);
  const save = async () => {
    try {
      const body = { ...f }; NUM.forEach(([k]) => { body[k] = Number(body[k]); });
      await api.put("/admin-x/rewards/config", body); toast("Earning rules saved"); onSaved(); return true;
    } catch (e) { toast.error(errMsg(e)); return false; }
  };
  return (
    <div className="bg-white border border-neutral-200 p-6 max-w-3xl space-y-6" data-testid="vip-settings-form">
      <label className="flex items-center gap-3 text-sm"><input type="checkbox" checked={f.enabled} onChange={(e) => setF({ ...f, enabled: e.target.checked })} data-testid="vip-setting-enabled" />
        Program is on (customers earn new rewards). Existing balances can always be spent.</label>
      <div className="grid sm:grid-cols-2 gap-5">
        {NUM.map(([k, l]) => <Field key={k} label={l}><input type="number" step="any" min="0" value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={inputCls} data-testid={`vip-setting-${k}`} /></Field>)}
        <Field label="Facebook page link"><input value={f.facebook_url || ""} onChange={(e) => setF({ ...f, facebook_url: e.target.value })} className={inputCls} data-testid="vip-setting-facebook_url" /></Field>
        <Field label="Instagram profile link"><input value={f.instagram_url || ""} onChange={(e) => setF({ ...f, instagram_url: e.target.value })} className={inputCls} data-testid="vip-setting-instagram_url" /></Field>
      </div>
      <p className="text-xs text-neutral-500">The amounts in “Ways to earn” on the VIP page update automatically. If you change the earn rate, also update the wording in Pages & Education › Somnio VIP and its FAQs.</p>
      <RecordedSave res="settings" id="rewards" onSave={save} value={f} label="Save earning rules" testId="vip-settings-save" onRestored={() => { onSaved(); window.setTimeout(() => window.location.reload(), 300); }} />
    </div>
  );
}
